import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastSeverity } from '../notification/notification.component';

@Injectable({
  providedIn: 'root',
})
export class SavedItemsService {
  private storageKey = environment.savedItemsLocalStorageName;

  private savedItemsCountSubject: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  constructor(
    private platform: Platform,
    private messageService: MessageService
  ) {
    if (this.platform.isBrowser) {
      const initialItemIds = this.getItemIds();
      this.savedItemsCountSubject.next(initialItemIds.length);
    }
  }

  get savedItemsCount$(): Observable<number> {
    return this.savedItemsCountSubject.asObservable();
  }

  getItemIds(): string[] {
    if (this.platform.isBrowser) {
      const itemIds = localStorage.getItem(this.storageKey);
      return itemIds ? JSON.parse(itemIds) : [];
    } else {
      return [];
    }
  }

  addProductToSavedItems(itemId: string): void {
    if (this.platform.isBrowser) {
      let itemIds = this.getItemIds();
      if (!itemIds.includes(itemId)) {
        itemIds.push(itemId);
        this.messageService.add({
          severity: ToastSeverity.Success,
          life: 3000,
          key: 'notifications',
          summary: 'Success',
          detail: `Item added to the saved list.`,
        });
      } else {
        itemIds = itemIds.filter((id) => id !== itemId);
        this.messageService.add({
          severity: ToastSeverity.Info,
          life: 3000,
          key: 'notifications',
          summary: 'Success',
          detail: `Item removed from the saved list.`,
        });
      }
      localStorage.setItem(this.storageKey, JSON.stringify(itemIds));
      // Emit the new state of saved items and their count
      this.savedItemsCountSubject.next(itemIds.length);
    }
  }

  productInSaved(itemId: string): boolean {
    if (this.platform.isBrowser) {
      let itemIds = this.getItemIds();
      if (!itemIds.includes(itemId)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  removeItemFromSaved(itemId: string): void {
    if (this.platform.isBrowser) {
      let itemIds = this.getItemIds();
      itemIds = itemIds.filter((id) => id !== itemId);
      localStorage.setItem(this.storageKey, JSON.stringify(itemIds));
      // Emit the new state of saved items and their count
      this.savedItemsCountSubject.next(itemIds.length);
    }
  }

  clearAllItemIds(): void {
    if (this.platform.isBrowser) {
      localStorage.removeItem(this.storageKey);
      // Emit the new state of saved items and their count
      this.savedItemsCountSubject.next(0);
    }
  }
}
